import H2 from 'UIComponents/elements/headings/H2';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { useState } from 'react';
import DebuggerPanelSourceSelectBody from 'automation-ui-canvas/components/panels/debugger-panel/DebuggerPanelSourceSelectBody';
import DebuggerPanelStepBody from 'automation-ui-canvas/components/panels/debugger-panel/DebuggerPanelStepBody';
import { useGetIsUngated } from 'automation-ui-core/hooks/authHooks';
import { getActionHeaderTitle } from 'automation-ui-action-features/records/recordsUtils';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PANEL_WIDTH = 480;
export const SingleActionTestPanel = ({
  flow,
  onClose,
  actionId
}) => {
  const isUngated = useGetIsUngated();
  const [objectId, setObjectId] = useState();
  const getTitle = getActionHeaderTitle({
    flowActions: flow.actions,
    firstActionId: flow.firstActionId,
    isUngated
  });
  const stepName = getTitle({
    actionId
  });
  return /*#__PURE__*/_jsxs(Panel, {
    "data-test-id": "single-action-test-panel",
    width: PANEL_WIDTH,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: stepName ? /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "singleActionTestPanel.headerWithName",
          options: {
            stepName
          }
        }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "singleActionTestPanel.headerNoName"
        })
      })
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsxs(PanelSection, {
        paddingInline: "0",
        paddingBlockStart: "0",
        blockSize: "100%",
        children: [/*#__PURE__*/_jsx(DebuggerPanelSourceSelectBody, {
          flowObjectTypeId: flow.getObjectTypeId(),
          onObjectIdSelected: setObjectId,
          objectId: objectId
        }), objectId && /*#__PURE__*/_jsx(DebuggerPanelStepBody, {
          flow: flow,
          objectId: objectId,
          actionId: actionId
        })]
      })
    })]
  });
};
export default SingleActionTestPanel;